import styled from "@emotion/styled";
import { Divider as ThemeDivider } from "theme-ui";

export const Divider = styled(ThemeDivider)({
  height: "1.5px",
  color: "var(--theme-ui-colors-primaryText)",
});
